<script>
export default {
	methods: {
		removeDups(names) {
			const unique = {};
			names.forEach(function(i) {
				if (!unique[i]) {
					unique[i] = true;
				}
			});
			return Object.keys(unique);
		}
	}
};
</script>
